module.exports = __webpack_public_path__ + "assets/chevron-down.55012182.svg";